import { KpiWindowType } from '@shared/enums/kpi-window-type';
import { WorkflowStepEnumType } from '@shared/enums/workflow-step.enum';
import { RestThresholdsConfiguration } from '@shared/interfaces/thresholds-configuration.interface';
import { RestUserModel } from '@shared/interfaces/user.interface';

export enum PortfolioKpiType {
  AvgTurnoverTime = 1,
  VacantCount = 2,
  OccupancyPercent = 3,
  Expirations30 = 4,
  Expirations60 = 5,
  Expirations90 = 6,
  MoveOuts30 = 7,
  MoveOuts60 = 8,
  MoveOuts90 = 9,
  ApplicationsTotal30 = 10,
  Preleased30 = 11,
  EstOccupancyPercent30 = 12,
  EstOccupancyPercent60 = 13,
  EstOccupancyPercent90 = 14,
  EstOccupancyPercentSmart30 = 15,
  EstOccupancyPercentSmart60 = 16,
  EstOccupancyPercentSmart90 = 17,
  ExpirationsSmart30 = 18,
  ExpirationsSmart60 = 19,
  ExpirationsSmart90 = 20,
  MoveOutTurnovers = 21,
  Notices = 22,
  Bids = 23,
  MakeReady = 24,
  Reno = 25,
  Punch = 26,
  Approval = 27,
  TotalTurnovers = 28,
  Marketing = 29,
  LeaseUp = 30,
  MoveIn = 31,
  UnleasedUnits = 32,
  NewApplications30 = 33,
  CancelledApplications30 = 34,
  PendingApplications30 = 35,
  DeniedApplications30 = 36,
  ApprovedApplications30 = 37,
  ConvertingApplications30 = 38,
  ConvertedApplications30 = 39,
  AvgMoveOut30 = 40,
  AvgBid30 = 41,
  AvgMakeReady30 = 42,
  AvgReno30 = 43,
  AvgLeaseUp30 = 44,
  AvgApprovalPunch30 = 45,
  AvgMoveOut60 = 46,
  AvgBid60 = 47,
  AvgMakeReady60 = 48,
  AvgReno60 = 49,
  AvgLeaseUp60 = 50,
  AvgApprovalPunch60 = 51,
  AvgMoveOut90 = 52,
  AvgBid90 = 53,
  AvgMakeReady90 = 54,
  AvgReno90 = 55,
  AvgLeaseUp90 = 56,
  AvgApprovalPunch90 = 57,
  Preleased60 = 58,
  Preleased90 = 59,
  ApplicationsTotal60 = 60,
  NewApplications60 = 61,
  CancelledApplications60 = 62,
  PendingApplications60 = 63,
  DeniedApplications60 = 64,
  ApprovedApplications60 = 65,
  ConvertingApplications60 = 66,
  ConvertedApplications60 = 67,
  ApplicationsTotal90 = 68,
  NewApplications90 = 69,
  CancelledApplications90 = 70,
  PendingApplications90 = 71,
  DeniedApplications90 = 72,
  ApprovedApplications90 = 73,
  ConvertingApplications90 = 74,
  ConvertedApplications90 = 75,
  AverageTurnTime60 = 76,
  AverageTurnTime90 = 77,
  Leasing30 = 78,
  Leasing60 = 79,
  Leasing90 = 80,
  VacancyLossMediumInOpenProperties = 81,
  VacancyLossMediumPerTurns = 82,
  VacancyLossHighInOpenProperties = 83,
  VacancyLossHighPerTurns = 84,
  AvgMoveOutNow = 85,
  AvgBidNow = 86,
  AvgMakeReadyNow = 87,
  AvgRenoNow = 88,
  AvgLeaseUpNow = 89,
  AvgPunchNow = 90,
  AvgApprovalNow = 91,
  AvgMoveInNow = 92,
  AverageTurnTimeNow = 93,
  UnleasedPercent = 94,
  AvgPunch30 = 95,
  AvgPunch60 = 96,
  AvgPunch90 = 97,
  AvgApproval30 = 98,
  AvgApproval60 = 99,
  AvgApproval90 = 100,
  AvgMoveIn30 = 101,
  AvgMoveIn60 = 102,
  AvgMoveIn90 = 103,
  AvgMoveOut6m = 104,
  AvgBid6m = 105,
  AvgMakeReady6m = 106,
  AvgReno6m = 107,
  AvgLeaseUp6m = 108,
  AvgPunch6m = 109,
  AvgApproval6m = 110,
  AvgMoveIn6m = 111,
  AverageTurnTime6m = 112,
  AvgMoveOut1y = 113,
  AvgBid1y = 114,
  AvgMakeReady1y = 115,
  AvgReno1y = 116,
  AvgLeaseUp1y = 117,
  AvgPunch1y = 118,
  AvgApproval1y = 119,
  AvgMoveIn1y = 120,
  AverageTurnTime1y = 121,
  AvgMoveOutAll = 122,
  AvgBidAll = 123,
  AvgMakeReadyAll = 124,
  AvgRenoAll = 125,
  AvgLeaseUpAll = 126,
  AvgPunchAll = 127,
  AvgApprovalAll = 128,
  AvgMoveInAll = 129,
  AverageTurnTimeAll = 130,
  VacancyLossNone = 131,
  VacancyLossNonePerTurn = 132,
  MoveOuts6m = 133,
  Expirations6m = 134,
  ExpirationsSmart6m = 135,
  ApplicationsTotal6m = 136,
  NewApplications6m = 137,
  CancelledApplications6m = 138,
  PendingApplications6m = 139,
  DeniedApplications6m = 140,
  ApprovedApplications6m = 141,
  ConvertingApplications6m = 142,
  ConvertedApplications6m = 143,
  Preleased6m = 144,
  EstOccupancyPercent6m = 145,
  EstOccupancyPercentSmart6m = 146,
  MoveOuts1y = 147,
  Expirations1y = 148,
  ExpirationsSmart1y = 149,
  ApplicationsTotal1y = 150,
  NewApplications1y = 151,
  CancelledApplications1y = 152,
  PendingApplications1y = 153,
  DeniedApplications1y = 154,
  ApprovedApplications1y = 155,
  ConvertingApplications1y = 156,
  ConvertedApplications1y = 157,
  Preleased1y = 158,
  EstOccupancyPercent1y = 159,
  EstOccupancyPercentSmart1y = 160,
  Leasing6m = 161,
  Leasing1y = 162,
  TimeToTurn30 = 163,
  TimeToTurn60 = 164,
  TimeToTurn90 = 165,
  TimeToTurnNow = 166,
  TimeToTurn6m = 167,
  TimeToTurn1y = 168,
  TimeToTurnAll = 169,
}

export interface RestPortfolioKpi {
  calculationDate: string;
  dateUpdated: string;
  kpiType: PortfolioKpiType;
  portfolioId: number;
  propertyId: number;
  unitsCount: number;
  value: number;
}

export enum KpiGroup {
  MoveOut = 'MoveOut',
  MakeReady = 'MakeReady',
  Reno = 'Reno',
  Punch = 'Punch',
  Approval = 'Approval',
  LeaseUp = 'LeaseUp',
  MoveIn = 'MoveIn',

  Occupancy = 'Occupancy',
  Expirations = 'Expirations',
  MoveOuts = 'Move-outs',
  Applications = 'Applications',
  PreLeased = 'Pre-leased',
  EstOccupancy = 'Est. Occupancy',
}

export interface KpiTableRow {
  propertyName?: string;
  propertyId: number;
  propertyManager?: RestUserModel;
  propertyManagerId?: number;
  totalUnits: number;
  kpiValue: number | undefined;
  trendPercent: number | undefined;
  wideTrendPercent: number | undefined;
  thresholdsConfiguration?: RestThresholdsConfiguration;
  workflowStepEnumType?: WorkflowStepEnumType;
}

export interface KpiTableExpandedRow {
  id?: number;
  name: string;
  totalUnits: number;
  kpiValue: number | undefined;
  trendPercent: number | undefined;
  wideTrendPercent: number | undefined;
  data: KpiTableRow[];
  thresholdsConfiguration?: RestThresholdsConfiguration;
  workflowStepEnumType?: WorkflowStepEnumType;
  expanded?: boolean;
}

export const kpiWorkflowStep = {
  [KpiGroup.MoveOut]: WorkflowStepEnumType.MoveOut,
  [KpiGroup.MakeReady]: WorkflowStepEnumType.MakeReady,
  [KpiGroup.Reno]: WorkflowStepEnumType.Reno,
  [KpiGroup.Punch]: WorkflowStepEnumType.Punch,
  [KpiGroup.Approval]: WorkflowStepEnumType.Approval,
  [KpiGroup.LeaseUp]: WorkflowStepEnumType.LeaseUp,
  [KpiGroup.MoveIn]: WorkflowStepEnumType.MoveIn,
};

export const kpiGroupWindowConfig: {
  [key in KpiGroup]?: {
    [window in KpiWindowType]?: {
      type: PortfolioKpiType;
      method: 'avg' | 'sum';
    };
  };
} = {
  [KpiGroup.MoveOut]: {
    [KpiWindowType.OpenTurns]: { type: PortfolioKpiType.AvgMoveOutNow, method: 'avg' },
    [KpiWindowType.Days30]: { type: PortfolioKpiType.AvgMoveOut30, method: 'avg' },
    [KpiWindowType.Days60]: { type: PortfolioKpiType.AvgMoveOut60, method: 'avg' },
    [KpiWindowType.Days90]: { type: PortfolioKpiType.AvgMoveOut90, method: 'avg' },
    [KpiWindowType.Months6]: { type: PortfolioKpiType.AvgMoveOut6m, method: 'avg' },
    [KpiWindowType.Months12]: { type: PortfolioKpiType.AvgMoveOut1y, method: 'avg' },
  },
  [KpiGroup.MakeReady]: {
    [KpiWindowType.OpenTurns]: { type: PortfolioKpiType.AvgMakeReadyNow, method: 'avg' },
    [KpiWindowType.Days30]: { type: PortfolioKpiType.AvgMakeReady30, method: 'avg' },
    [KpiWindowType.Days60]: { type: PortfolioKpiType.AvgMakeReady60, method: 'avg' },
    [KpiWindowType.Days90]: { type: PortfolioKpiType.AvgMakeReady90, method: 'avg' },
    [KpiWindowType.Months6]: { type: PortfolioKpiType.AvgMakeReady6m, method: 'avg' },
    [KpiWindowType.Months12]: { type: PortfolioKpiType.AvgMakeReady1y, method: 'avg' },
  },
  [KpiGroup.Reno]: {
    [KpiWindowType.OpenTurns]: { type: PortfolioKpiType.AvgRenoNow, method: 'avg' },
    [KpiWindowType.Days30]: { type: PortfolioKpiType.AvgReno30, method: 'avg' },
    [KpiWindowType.Days60]: { type: PortfolioKpiType.AvgReno60, method: 'avg' },
    [KpiWindowType.Days90]: { type: PortfolioKpiType.AvgReno90, method: 'avg' },
    [KpiWindowType.Months6]: { type: PortfolioKpiType.AvgReno6m, method: 'avg' },
    [KpiWindowType.Months12]: { type: PortfolioKpiType.AvgReno1y, method: 'avg' },
  },
  [KpiGroup.Punch]: {
    [KpiWindowType.OpenTurns]: { type: PortfolioKpiType.AvgPunchNow, method: 'avg' },
    [KpiWindowType.Days30]: { type: PortfolioKpiType.AvgPunch30, method: 'avg' },
    [KpiWindowType.Days60]: { type: PortfolioKpiType.AvgPunch60, method: 'avg' },
    [KpiWindowType.Days90]: { type: PortfolioKpiType.AvgPunch90, method: 'avg' },
    [KpiWindowType.Months6]: { type: PortfolioKpiType.AvgPunch6m, method: 'avg' },
    [KpiWindowType.Months12]: { type: PortfolioKpiType.AvgPunch1y, method: 'avg' },
  },
  [KpiGroup.Approval]: {
    [KpiWindowType.OpenTurns]: { type: PortfolioKpiType.AvgApprovalNow, method: 'avg' },
    [KpiWindowType.Days30]: { type: PortfolioKpiType.AvgApproval30, method: 'avg' },
    [KpiWindowType.Days60]: { type: PortfolioKpiType.AvgApproval60, method: 'avg' },
    [KpiWindowType.Days90]: { type: PortfolioKpiType.AvgApproval90, method: 'avg' },
    [KpiWindowType.Months6]: { type: PortfolioKpiType.AvgApproval6m, method: 'avg' },
    [KpiWindowType.Months12]: { type: PortfolioKpiType.AvgApproval1y, method: 'avg' },
  },
  [KpiGroup.LeaseUp]: {
    [KpiWindowType.OpenTurns]: { type: PortfolioKpiType.AvgLeaseUpNow, method: 'avg' },
    [KpiWindowType.Days30]: { type: PortfolioKpiType.AvgLeaseUp30, method: 'avg' },
    [KpiWindowType.Days60]: { type: PortfolioKpiType.AvgLeaseUp60, method: 'avg' },
    [KpiWindowType.Days90]: { type: PortfolioKpiType.AvgLeaseUp90, method: 'avg' },
    [KpiWindowType.Months6]: { type: PortfolioKpiType.AvgLeaseUp6m, method: 'avg' },
    [KpiWindowType.Months12]: { type: PortfolioKpiType.AvgLeaseUp1y, method: 'avg' },
  },
  [KpiGroup.MoveIn]: {
    [KpiWindowType.OpenTurns]: { type: PortfolioKpiType.AvgMoveInNow, method: 'avg' },
    [KpiWindowType.Days30]: { type: PortfolioKpiType.AvgMoveIn30, method: 'avg' },
    [KpiWindowType.Days60]: { type: PortfolioKpiType.AvgMoveIn60, method: 'avg' },
    [KpiWindowType.Days90]: { type: PortfolioKpiType.AvgMoveIn90, method: 'avg' },
    [KpiWindowType.Months6]: { type: PortfolioKpiType.AvgMoveIn6m, method: 'avg' },
    [KpiWindowType.Months12]: { type: PortfolioKpiType.AvgMoveIn1y, method: 'avg' },
  },
  [KpiGroup.Occupancy]: {
    [KpiWindowType.OpenTurns]: { type: PortfolioKpiType.OccupancyPercent, method: 'avg' },
    [KpiWindowType.Days30]: { type: PortfolioKpiType.OccupancyPercent, method: 'avg' },
    [KpiWindowType.Days60]: { type: PortfolioKpiType.OccupancyPercent, method: 'avg' },
    [KpiWindowType.Days90]: { type: PortfolioKpiType.OccupancyPercent, method: 'avg' },
    [KpiWindowType.Months6]: { type: PortfolioKpiType.OccupancyPercent, method: 'avg' },
    [KpiWindowType.Months12]: { type: PortfolioKpiType.OccupancyPercent, method: 'avg' },
  },
  [KpiGroup.Expirations]: {
    [KpiWindowType.OpenTurns]: { type: PortfolioKpiType.Expirations30, method: 'sum' },
    [KpiWindowType.Days30]: { type: PortfolioKpiType.Expirations30, method: 'sum' },
    [KpiWindowType.Days60]: { type: PortfolioKpiType.Expirations60, method: 'sum' },
    [KpiWindowType.Days90]: { type: PortfolioKpiType.Expirations90, method: 'sum' },
    [KpiWindowType.Months6]: { type: PortfolioKpiType.Expirations6m, method: 'sum' },
    [KpiWindowType.Months12]: { type: PortfolioKpiType.Expirations1y, method: 'sum' },
  },
  [KpiGroup.MoveOuts]: {
    [KpiWindowType.OpenTurns]: { type: PortfolioKpiType.MoveOuts30, method: 'sum' },
    [KpiWindowType.Days30]: { type: PortfolioKpiType.MoveOuts30, method: 'sum' },
    [KpiWindowType.Days60]: { type: PortfolioKpiType.MoveOuts60, method: 'sum' },
    [KpiWindowType.Days90]: { type: PortfolioKpiType.MoveOuts90, method: 'sum' },
    [KpiWindowType.Months6]: { type: PortfolioKpiType.MoveOuts6m, method: 'sum' },
    [KpiWindowType.Months12]: { type: PortfolioKpiType.MoveOuts1y, method: 'sum' },
  },
  [KpiGroup.Applications]: {
    [KpiWindowType.OpenTurns]: { type: PortfolioKpiType.ApplicationsTotal30, method: 'sum' },
    [KpiWindowType.Days30]: { type: PortfolioKpiType.ApplicationsTotal30, method: 'sum' },
    [KpiWindowType.Days60]: { type: PortfolioKpiType.ApplicationsTotal60, method: 'sum' },
    [KpiWindowType.Days90]: { type: PortfolioKpiType.ApplicationsTotal90, method: 'sum' },
    [KpiWindowType.Months6]: { type: PortfolioKpiType.ApplicationsTotal6m, method: 'sum' },
    [KpiWindowType.Months12]: { type: PortfolioKpiType.ApplicationsTotal1y, method: 'sum' },
  },
  [KpiGroup.PreLeased]: {
    [KpiWindowType.OpenTurns]: { type: PortfolioKpiType.Preleased30, method: 'sum' },
    [KpiWindowType.Days30]: { type: PortfolioKpiType.Preleased30, method: 'sum' },
    [KpiWindowType.Days60]: { type: PortfolioKpiType.Preleased60, method: 'sum' },
    [KpiWindowType.Days90]: { type: PortfolioKpiType.Preleased90, method: 'sum' },
    [KpiWindowType.Months6]: { type: PortfolioKpiType.Preleased6m, method: 'sum' },
    [KpiWindowType.Months12]: { type: PortfolioKpiType.Preleased1y, method: 'sum' },
  },
  [KpiGroup.EstOccupancy]: {
    [KpiWindowType.OpenTurns]: { type: PortfolioKpiType.EstOccupancyPercent30, method: 'avg' },
    [KpiWindowType.Days30]: { type: PortfolioKpiType.EstOccupancyPercent30, method: 'avg' },
    [KpiWindowType.Days60]: { type: PortfolioKpiType.EstOccupancyPercent60, method: 'avg' },
    [KpiWindowType.Days90]: { type: PortfolioKpiType.EstOccupancyPercent90, method: 'avg' },
    [KpiWindowType.Months6]: { type: PortfolioKpiType.EstOccupancyPercent6m, method: 'avg' },
    [KpiWindowType.Months12]: { type: PortfolioKpiType.EstOccupancyPercent1y, method: 'avg' },
  },
};
